module.exports = __webpack_public_path__ + "img/default-user.a04d849c.jpg";